const getDealsInvoice = (state) => state.dealInvoice
export default {
  getDealsInvoice,
}
